import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormDropDown } from "../../components/form/dropdown";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormLocationPickerField } from "../../components/map/map-selector";
import { FormDateField } from "../../components/form/date";
import { FormDocumentField } from "../../components/form/document-field";
import { api } from "../../redux/apis/api";

const EditCustomer = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [userList, setuserList] = useState([]);

  const initialValues = {
    id: params?.id,
    name: data?.name ?? "",
    address: data?.address ?? "",
    state_id: data?.state_id ?? "",
    city_id: data?.city_id ?? "",
    location: data?.location ?? {
      lat: "",
      lng: "",
    },
    visiting_card_photo: data?.visiting_card_photo ?? "",
    outside_place_photo: data?.outside_place_photo ?? "",
    type_of_client: data?.type_of_client ?? "",
    contact_name: data?.contact_name ?? "",
    contact_number: data?.contact_number ?? "",
    price_agreed_upon: data?.price_agreed_upon ?? "",
    status: data?.status ?? "",
    type_of_billing: data?.type_of_billing ?? "",
    billing_name: data?.billing_name ?? "",
    billing_address: data?.billing_address ?? "",
    billing_city: data?.billing_city ?? "",
    billing_state: data?.billing_state ?? "",
    billing_pincode: data?.billing_pincode ?? "",
    pan_number: data?.pan_number ?? "",
    gst_number: data?.gst_number ?? "",
    last_order_on: data?.last_order_on ?? "",
    customer_type: data?.customer_type ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    api
      .post(`/customer/edit`, values)
      .then((response) => {
        successToast(response.message);
        naviagte(`/customer/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/customer/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
    fetchUserDropDownData();
  }, []);

  const typeOfClientOptions = [
    {
      label: "small",
      value: "small",
    },
    {
      label: "large",
      value: "large",
    },
    {
      label: "medium",
      value: "medium",
    },
  ];

  const statusOptions = [
    {
      label: "active",
      value: "active",
    },
    {
      label: "inactive",
      value: "inactive",
    },
    {
      label: "closed",
      value: "closed",
    },
    {
      label: "lost",
      value: "lost",
    },
  ];

  const typeOfBillingOptions = [
    {
      label: "half",
      value: "half",
    },
    {
      label: "full",
      value: "full",
    },
    {
      label: "none",
      value: "none",
    },
  ];

  const customerTypesOptions = [
    {
      label: "Individual",
      value: "individual",
    },
    {
      label: "Shop",
      value: "shop",
    },
    {
      label: "Distributor",
      value: "distributor",
    },
    {
      label: "Tile layer",
      value: "tile_layer",
    },
    {
      label: "Contractor",
      value: "contractor",
    },
    {
      label: "Industry",
      value: "industry",
    },
  ];

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      customer - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => naviagte("/customer/list")}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"name"}
                        label={"name"}
                        placeholder={`Enter company name`}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="state_id"
                        label="state"
                        options={stateList}
                        value={stateList?.find(
                          (item) => item?.value === values?.state_id
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="city_id"
                        label="city"
                        options={citiesList}
                        value={citiesList?.find(
                          (item) => item?.value === values?.city_id
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"address"}
                        label={"address"}
                        placeholder={`Enter company address`}
                        rows={3}
                      />
                    </div>
                    <div className="my-4">
                      <FormDocumentField
                        name={"visiting_card_photo"}
                        label={"visiting card photo"}
                      />
                    </div>
                    <div className="my-4">
                      <FormDocumentField
                        name={"outside_place_photo"}
                        label={"outside place photo"}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"contact_name"}
                        label={"contact name"}
                        placeholder={`Enter contact name`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"contact_number"}
                        label={"contact number"}
                        placeholder={`Enter contact number`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"price_agreed_upon"}
                        label={"price agreed upon"}
                        placeholder={`Enter price agreed upon`}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="type_of_client"
                        label="type of client"
                        options={typeOfClientOptions}
                        value={typeOfClientOptions?.find(
                          (item) => item?.value === values?.type_of_client
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="status"
                        label="status"
                        options={statusOptions}
                        value={statusOptions?.find(
                          (item) => item?.value === values?.status
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="type_of_billing"
                        label="type of billing"
                        options={typeOfBillingOptions}
                        value={typeOfBillingOptions?.find(
                          (item) => item?.value === values?.type_of_billing
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="customer_type"
                        label="customer type"
                        options={customerTypesOptions}
                        value={customerTypesOptions?.find(
                          (item) => item?.value === values?.customer_type
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"billing_name"}
                        label={"billing name"}
                        placeholder={`Enter billing name`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextAreaField
                        name={"billing_address"}
                        label={"billing address"}
                        placeholder={`Enter billing address`}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="billing_state"
                        label="billing state"
                        options={stateList}
                        value={stateList?.find(
                          (item) => item?.value === values?.billing_state
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormDropDown
                        name="billing_city"
                        label="billing city"
                        options={citiesList}
                        value={citiesList?.find(
                          (item) => item?.value === values?.billing_city
                        )}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"billing_pincode"}
                        label={"billing pincode"}
                        placeholder={`Enter billing pincode`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"pan_number"}
                        label={"pan number"}
                        placeholder={`Enter pan number`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"gst_number"}
                        label={"gst number"}
                        placeholder={`Enter gst number`}
                      />
                    </div>
                    <div className="my-4">
                      <FormDateField
                        name={"last_order_on"}
                        label={"last order on"}
                      />
                    </div>
                    <div className="my-4">
                      <FormLocationPickerField
                        name={"location"}
                        label={"location"}
                        value={values?.location}
                      />
                    </div>
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default EditCustomer;
